export default __webpack_public_path__ + "static/media/plus.8dd4ea71.svg";